module.exports = __webpack_public_path__ + "img/Group 2008.e5d26317.svg";